/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
    Box,
    TextField,
    Button,
    Typography,
    Link,
    Stack,
    Chip,
    Pagination,
} from "@mui/material";
import React, { useState } from "react";
import { ParamsGetWarehouse } from "../../constants/types";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import useWarehouse from "../../services/queries/useWarehouse";
import useUser from "../../services/queries/useUser";
import Spinner from "../Spinner/Spinner";
import ModalAlertPro from "../ModalAlertPro/ModalAlertPro";
import CardInfoToko from "./CardInfoToko";
import { useWarehouseModal } from "../../context/warehouseModalContext";
import {
    getLocalWarehouseId,
    setLocalWarehouseId,
} from "../../utils/handleChangeWarehouseId";
import Select, { StylesConfig } from "react-select";
import ModalWarehouse from "../ModalWarehouse/ModalWarehouse";
import ModalDeleteWarehouse from "../ModalDeleteWarehouse/ModalDeleteWarehouse";

interface IInfoTokoProps {}

interface IOption {
    value: number;
    label: string;
}

const InfoToko = (props: IInfoTokoProps) => {
    const { data: user, refetch: refetchUser } = useUser();
    const initialParamsWarehouse = {
        size: 4,
        page: 1,
        search: "",
    };
    const initialParamsAllWarehouse = {
        size: 500,
        page: 1,
        search: "",
    };
    const [paramsWarehouse, setParamsWarehouse] = useState<ParamsGetWarehouse>(
        initialParamsWarehouse,
    );
    const {
        data: warehouse,
        status: statusWarehouse,
        refetch: refetchWarehouse,
        isLoading: isLoadingWarehouse,
    } = useWarehouse(paramsWarehouse);
    const { data: allWarehouse } = useWarehouse(initialParamsAllWarehouse);
    const { openModalWarehouse } = useWarehouseModal();
    const [search, setSearch] = useState("");
    const optionsWarehouse = React.useMemo(
        () =>
            allWarehouse?.content.map((warehouses) => ({
                value: Number(warehouses.id),
                label: warehouses.nama,
            })),
        [allWarehouse?.content],
    );
    const [isOpenModalAlertPro, setIsOpenModalAlertPro] = useState(false);

    const warehouseId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalWarehouseId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const defaultSelected = optionsWarehouse?.find(
        (li) => li.value === warehouseId,
    );
    const [selectWarehouse, setSelectWarehouse] = React.useState<
        IOption | undefined
    >(defaultSelected);

    const warehouseData = React.useMemo(() => {
        if (warehouseId) {
            return allWarehouse?.content.find((li) => li.id === warehouseId);
        }
        return allWarehouse?.content[0];
    }, [allWarehouse?.content, warehouseId]);

    const customStyles: StylesConfig<any> = {
        control: (base: any, state: any) => ({
            ...base,
            background: "#FFFF",
            borderRadius: 8,
            borderColor: state.isFocused ? warehouseData?.warna : "#d4d4d4",
            borderWidth: 1,
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                borderColor: state.isFocused ? warehouseData?.warna : "black",
            },
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? undefined
                    : isSelected
                    ? "#f5f5f5"
                    : isFocused
                    ? "#f5f5f5"
                    : undefined,
                color: isDisabled ? "#ccc" : isSelected ? "black" : "black",
                cursor: isDisabled ? "not-allowed" : "default",

                ":active": {
                    ...styles[":active"],
                    backgroundColor: !isDisabled
                        ? isSelected
                            ? "black"
                            : "white"
                        : undefined,
                },
            };
        },
        input: (styles) => ({ ...styles, width: 150 }),
        placeholder: (styles) => ({ ...styles }),
        singleValue: (styles, { data }) => ({
            ...styles,
            borderBlockEndWidth: 0,
        }),
    };

    if (statusWarehouse === "loading") {
        return (
            <Stack
                display="grid"
                gridTemplateColumns="1fr"
                alignItems="center"
                height={400}
                position="relative"
            >
                <Spinner />
            </Stack>
        );
    }

    return (
        <React.Fragment>
            <Stack
                direction="row"
                spacing={2}
                marginBottom={2}
                alignItems="center"
            >
                <Typography variant="h6" fontWeight="bold">
                    Pindah Warehouse
                </Typography>
                {user && user?.countProWarehouse > 0 ? null : (
                    <Chip
                        label="PRO"
                        size="small"
                        onClick={() => setIsOpenModalAlertPro(true)}
                    />
                )}
            </Stack>
            <Stack
                component={user?.countProWarehouse === 0 ? Link : Stack}
                onClick={() => {
                    if (user && user?.countProWarehouse >= 1) {
                        return;
                    }
                    setIsOpenModalAlertPro(true);
                }}
                underline="none"
                direction="column"
                spacing={1}
                marginTop={2}
                sx={{
                    width: { xs: 300, sm: 400 },
                    cursor:
                        user?.countProWarehouse === 0 ? "pointer" : undefined,
                }}
            >
                <Select
                    styles={customStyles}
                    value={selectWarehouse}
                    options={optionsWarehouse}
                    onChange={(e) => {
                        const selected = optionsWarehouse?.find(
                            (li) => li.value === e?.value,
                        );
                        if (selected) {
                            setSelectWarehouse(selected);
                        }
                    }}
                    isLoading={isLoadingWarehouse}
                    isDisabled={user?.countProWarehouse === 0}
                    components={{
                        IndicatorSeparator: () => null,
                    }}
                    menuPlacement="auto"
                />
                <Button
                    disabled={user?.countProWarehouse === 0}
                    variant="contained"
                    onClick={() => {
                        if (selectWarehouse?.value) {
                            user?.userId &&
                                setLocalWarehouseId(
                                    user?.userId,
                                    selectWarehouse?.value,
                                );
                            window.location.reload();
                        }
                    }}
                >
                    Simpan Perubahan
                </Button>
            </Stack>
            <Typography
                variant="h6"
                marginBottom={2}
                marginTop={8}
                fontWeight="bold"
            >
                Pengaturan Warehouse
            </Typography>
            <Stack
                display="flex"
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                marginBottom={2}
            >
                <TextField
                    placeholder="Cari nama warehouse..."
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyPress={(e) => {
                        e.key === "Enter"
                            ? setParamsWarehouse((prev) => ({
                                  ...prev,
                                  search: search,
                                  page: 1,
                              }))
                            : undefined;
                    }}
                    InputProps={{
                        endAdornment: (
                            <Link
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                onClick={() =>
                                    setParamsWarehouse((prev) => ({
                                        ...prev,
                                        search: search,
                                        page: 1,
                                    }))
                                }
                                sx={{ cursor: "pointer" }}
                            >
                                <SearchIcon fontSize="small" />
                            </Link>
                        ),
                        style: {
                            backgroundColor: "white",
                        },
                    }}
                    variant="outlined"
                />
                <Button
                    variant="contained"
                    size="large"
                    startIcon={<AddIcon />}
                    onClick={() => openModalWarehouse()}
                    sx={{ display: "none", height: "40px" }}
                >
                    Tambah Warehouse
                </Button>
            </Stack>
            <Box
                display="grid"
                gridTemplateColumns="repeat(auto-fill, minmax(300px, 1fr))"
                gap={3}
            >
                {warehouse && warehouse.totalElements > 0 ? (
                    warehouse.content.map((li) => (
                        <CardInfoToko
                            key={li.id}
                            id={Number(li.id)}
                            data={li}
                        />
                    ))
                ) : (
                    <Box
                        display="flex"
                        flex={1}
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        height="100%"
                    >
                        <Typography variant="h5" fontWeight="bold">
                            Warehouse tidak ditemukan
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box display="flex" justifyContent="center" paddingY={2}>
                <Pagination
                    color="primary"
                    count={Math.ceil(
                        Number(
                            warehouse &&
                                warehouse?.totalElements /
                                    initialParamsWarehouse.size,
                        ),
                    )}
                    page={paramsWarehouse.page}
                    onChange={(event, value) => {
                        setParamsWarehouse((prev) => ({
                            ...prev,
                            page: value,
                        }));
                    }}
                    siblingCount={0}
                    // sx={{ justifyContent: "center" }}
                />
            </Box>
            <ModalWarehouse
                refetchWarehouse={refetchWarehouse}
                refetchUser={refetchUser}
            />
            <ModalDeleteWarehouse refetch={refetchWarehouse} />
            {warehouseData && (
                <ModalAlertPro
                    isOpenModalAlertPro={isOpenModalAlertPro}
                    closeModalAlertPro={() => setIsOpenModalAlertPro(false)}
                    dataWarehouse={{
                        id: Number(warehouseData?.id),
                        nama: warehouseData?.nama,
                    }}
                />
            )}
        </React.Fragment>
    );
};

export default InfoToko;
